var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIconUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3039"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 254",
    cx: 6,
    cy: 6,
    r: 3,
    fill: "#BB0000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 255",
    cx: 6,
    cy: 6,
    r: 5.5,
    stroke: "#BB0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIconUser);
export default __webpack_public_path__ + "static/media/mapIconUser.5ee617ab6a742d5d710a848be2541d5b.svg";
export { ForwardRef as ReactComponent };